<template>
  <el-dialog 
    v-if="visible"
    v-el-drag-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    :before-close="closeDialog"
    append-to-body
    width="62.5%"
    top="8vh"
    center
    >
    <dialog-header
      slot="title"
      :title="$t('public.choseObd')"
      @close="closeDialog"
    />
    <app-search>
      <div slot="content">
        <el-form inline :model="listQuery" label-width="80px">
          <el-form-item :label="$t('public.obdCode')+'：'">
            <el-input v-model="listQuery.barCode" :placeholder="$t('public.obdCode')" clearable />
          </el-form-item>
        </el-form>
      </div>
      <!-- 清空查询按钮 -->
      <app-search-button
        slot="bottom"
        :is-collapse="false"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <div class="add-btn">
      <div class="add-btn-left">
        <el-button
          v-if="!view"
          v-waves
          class="filter-item"
          type="primary"
          size="mini"
          @click="addObd"
          >
          {{$t('system.company.addObd')}}
        </el-button>
        <el-button
          v-if="!view"
          v-waves
          class="filter-item"
          type="primary"
          size="mini"
          @click="deleteObd"
          >
          {{$t('system.company.removeObd')}}
        </el-button>
        <el-button
          v-waves
          class="filter-item"
          type="primary"
          size="mini"
          @click="importObd"
          :disabled="isChannel"
          >
          {{$t('public.import')}}
        </el-button>
        <el-button
          v-waves
          class="filter-item"
          type="primary"
          size="mini"
          @click="exportObd"
          >
          {{$t('public.export')}}
        </el-button>
      </div>
    </div>
    <el-table
      ref="tableList"
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @row-click="clickRow"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
    >
      <el-table-column
        type="selection"
        width="55"
        align="center"
      />
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in tableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :min-width="item.width"
        :align="item.position"
        :sortable="item.sortable"
        />
    </el-table>
    <!-- 分页 -->
    <div style="padding:10px 0" :class="[total>0?'visible':'hidden','pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <select-obd 
      :visible.sync="selectObdVisible"
      :id="id"
      @refresh="listLoad"
    />
    <import-dialog 
      :action="importConfig.url"
      :template-url="importConfig.template"
      :visibles.sync="importConfig.visible"
      append-to-body
      @upload-success="reloadList"
      >
      <result-dialog
        :visibles.sync="importConfig.resultVisible"
        :data="importConfig.result"
        :text="importConfig.text"
        :keys="'terminal'"
        :message="$t('baseData.terminalmanage.terminalInfo.message.noImportInfo')"
        :is-show="importConfig.visible"
        >
      </result-dialog>
    </import-dialog>
  </el-dialog>
</template>
<script>
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import importDialog from '@/components/importDialog'
import resultDialog from '@/components/resultDialog'
import SelectObd from './selectObd'

import { obdListUrl, deleteObdUrl, importObdUrl, exportObdUrl } from '@/api/system/company'
import resolve from '@/api/resolve'
export default {
  mixins: [pagingMixin, otherHeight, tableStyle],
  components: { SelectObd, importDialog, resultDialog },
  props: {
    visible: Boolean,
    view: Boolean,
    id: String
  },
  data() {
    return {
      listQuery: {
        barCode: ''
      },
      tableList: [
        { value: this.$t('public.obdCode'), prop: 'barCode', position: 'center' },
        { value: this.$t('public.terminal'), prop: 'terminalCode', position: 'center' },
        { value: this.$t('public.createTime'), prop: 'createdOn', position: 'center' },
        { value: this.$t('public.expirationTime'), prop: 'expireTime', position: 'center' }
      ],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      multipleSelection: [],
      selectObdVisible: false,
      importConfig: {
        visible: false,
        url: '',
        template: '/file/upload/template/importObd.xlsx',
        text: this.$t('public.obdCode'),
        resultVisible: false
      },
      isChannel: false
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.listLoad()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight * 0.4
    })
    window.onresize = ()=> {
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight * 0.4
      })
    }
  },
  created() {
    let roles = []
    if (this.$store.state.user.userInfo.roles) {
      roles = this.$store.state.user.userInfo.roles
      if(roles[0].weight == 300 || roles[0].weight == 310) {
        this.isChannel = true
      }
    }
  },
  methods: {
    // 关闭dialog
    closeDialog() {
      // this.restData()
      this.$emit('update:visible', false)
    },
    listLoad() {
      if (!this.visible) {
        return
      }
      this.listLoading = true
      this.$http.post(resolve(obdListUrl, this.id), this.listQuery).then(({ data }) => {
        if (data.code === 0) {
          this.list = data.data
          this.total = data.total
        }
      }).finally(() => {
        this.listLoading = false
      })
    },
    clickRow(row) {
      this.$refs.tableList.toggleRowSelection(row)
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    checkSelection () {
      if (this.multipleSelection.length < 1) {
        this.$alert( this.$t('public.deleteTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
        return false
      }
      return true
    },
    addObd() {
      this.selectObdVisible = true
    },
    deleteObd() {
      if (!this.checkSelection()) {
        return
      }
      this.$http.delete(resolve(deleteObdUrl, this.id), {
        data: this.multipleSelection.map(row => row.terminalId)
      }).then(({ data }) => {
        if (data.code == 0) {
          this.listLoad()
        }
      })
    },
    importObd() {
      this.importConfig.url = resolve(importObdUrl, this.id)
      this.importConfig.visible = true
    },
    // 导入成功之后刷新list
    reloadList(data) {
      this.importConfig.result = data
      this.importConfig.resultVisible = true
      this.listLoad()
    },
    exportObd() {
      const postData = {
        ...this.listQuery,
        id: this.id
      }
      this.$http.post(exportObdUrl, postData, {
        responseType: 'arraybuffer'
      })
    }
  }
}
</script>
